import { FormGroup, FormParagraph } from '@ksyos/design-system';

interface IFormGroupReadProps {
    label: string;
    value: string | null;
}

export function FormGroupRead(props: IFormGroupReadProps) {
    if (!props.value) {
        return null;
    }

    return (
        <FormGroup label={props.label}>
            <FormParagraph>{props.value}</FormParagraph>
        </FormGroup>
    );
}
